import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import RounderContainer from '@r1-frontend/ui-react/experimental/containers/RounderContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Router from './Router';

export const StyledRouterCard = styled(Router)`
    position: relative;
    flex-direction: column;
    background-color: ${COLORS.BgSurface};

    flex-wrap: nowrap;
  
    width: 164px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        width: 304px;
    }

    & > ${IndentContainer} > ${RounderContainer} {
        background-color: ${COLORS.TextWhite};
    }
    
    & > ${IndentContainer}:last-child {
        margin-top: auto;
    }
    
    & > ${IndentContainer}[data-role='button']  {
        cursor: pointer;
    }
`;

export const DesktopFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
`;

export const Block = styled.div`
    display: block;
`;
